import { useFetchData, useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import LmsTable from "../ui/LmsTable";
import { GlobalConstants } from "../../constants/GlobalConstants";
import { useState } from "react";
import LmsActionDropdown from "../ui/LmsActionDropdown";

const MainTable = () => {
  const rmsOptions = "/salesteam/list-regional-sales-manager-contacts"; 
  const sseOptions = "/salesteam/list-senior-sales-executive-contacts";
  const loBypassOptions = "/salesteam/list-bypass-recipient"; 
  const [dropdownValues, setDropdownValues] = useState({});
  const rmsValue = dropdownValues[rmsOptions];
  const sseValue = dropdownValues[sseOptions];
  const loBypassValue = dropdownValues[loBypassOptions];
  
  const handleDropdownChange = (e, { name, value }) => {
    setDropdownValues({ ...dropdownValues, [name]: value });
  };

  const handleUpdateRsmData = (selectedIds) => {
    return { ids: selectedIds, regionalSalesManagerId: rmsValue }; 
  };

  const handleUpdateSseData = (selectedIds) => {
    return { ids: selectedIds, seniorSalesExecutiveId: sseValue }; 
  };

  const handleUpdateLoBypassData = (selectedIds) => {
    return { ids: selectedIds, bypassId: loBypassValue };
  };

  const handleRemoveBypass = (selectedIds) => {
    return selectedIds;
  };

  const handleRemoveLoanOfficerSalesManager = (selectedIds) => {
    return selectedIds;
  };
  
  const actionButtons = [
    "add", 
    "edit", 
    {
      action: "submitselected",
      method: "DELETE",
      text: "Delete",
      submitSuffix: "salesteam", 
      confirmationMessage: "Are you sure that you want to delete these records?",
      data: handleRemoveLoanOfficerSalesManager,
      icon: GlobalConstants.Icons.DELETE,
      refreshDataOnSuccess: true,
    }, 
    "export",
    <LmsActionDropdown label={"RSM"} optionsSuffix={rmsOptions} handleChange={handleDropdownChange} values={dropdownValues} />,
    {
      action: "submitselected",
      text: "Update",
      submitSuffix: "salesteam/loan-officer-lo-regional-sales-manager",
      confirmationMessage: "Are you sure you want to update RSM for the selected Loan Officer Manager(s)?",
      method: "PUT", 
      icon: GlobalConstants.Icons.SAVE,
      data: handleUpdateRsmData,
      refreshDataOnSuccess: true,
      isDisabled: (selectedIds) => true || !rmsValue || selectedIds.length === 0, // The update RSM button is not enabled in legacy LMS
    },
    <LmsActionDropdown label={"SSE"} optionsSuffix={sseOptions} handleChange={handleDropdownChange} values={dropdownValues}/>,
    {
      action: "submitselected",
      text: "Update",
      confirmationMessage: "Are you sure you want to update Sr Sales Exec for the selected Loan Officer(s)?",
      submitSuffix: "salesteam/loan-officer-senior-sales-executive",
      method: "PUT",
      icon: GlobalConstants.Icons.SAVE,
      data: handleUpdateSseData,
      refreshDataOnSuccess: true,
      isDisabled: (selectedIds) => !sseValue || selectedIds.length === 0,
    },
    <LmsActionDropdown label={"LO Bypass"} optionsSuffix={loBypassOptions} handleChange={handleDropdownChange} values={dropdownValues}/>,
    {
      action: "submitselected",
      text: "Update",
      confirmationMessage: "Are you sure you want to update LO Bypass for the selected record(s)?",
      submitSuffix: "salesteam/loan-officer-bypass",
      method: "PUT",
      icon: GlobalConstants.Icons.SAVE,
      data: handleUpdateLoBypassData,
      refreshDataOnSuccess: true,
      isDisabled: (selectedIds) => !loBypassValue || selectedIds.length === 0,
    },
    {
      action: "submitselected",
      text: "Remove Bypass",
      confirmationMessage: "Are you sure you want to remove Bypass for the selected record(s)?",
      submitSuffix: "salesteam/remove-bypass",
      method: "DELETE", 
      icon: GlobalConstants.Icons.ARCHIVE,
      data: handleRemoveBypass,
      refreshDataOnSuccess: true,
    },
  ];

  return <LmsTable
    actionButtons={actionButtons as any}
    apiSuffix="/salesteam/loan-officers"
    deleteSuffix= "salesteam"
    columnLabelsDictionary={{ bypassOrganizationContact: "Bypass Recipient" }}
  />;
};

const addLoanOfficerSalesManagerFormFields = (myForm) => {
  myForm.addCenteredGroup([myForm.getDropdownField("Regional Sales Manager", "salesteam/list-regional-sales-manager-contacts", { name: "rsmOrganizationContactId", required: true })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Senior Sales Executive", "salesteam/list-senior-sales-executive-contacts", { dependencyField: "rsmOrganizationContactId", name: "reportsToOrganizationContactId", required: true })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Loan Officers", "salesteam/list-loan-officers", { name: "initialOrganizationContactIds", dropdownMultiple: true, required: true })]); 
  myForm.addDividerField({ dividerIsHidden: true });
  return myForm;
};

const editLoanOfficerSalesManagerFormFields = (myForm) => {
  myForm.addCenteredGroup([myForm.getDropdownField("Regional Sales Manager", "salesteam/list-regional-sales-manager-contacts", { name: "rsmOrganizationContactId", required: true })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Senior Sales Executive", "salesteam/list-senior-sales-executive-contacts", { dependencyField: "rsmOrganizationContactId", name: "reportsToOrganizationContactId", required: true })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Loan Officer", "salesteam/list-loan-officers", { name: "organizationContactId", required: true })]);
  myForm.addCenteredGroup([myForm.getInputField("Enable Notification Bypass", { name: "enableNotificationBypass", field: "checkbox", inline: true })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Bypass Recipient", "/salesteam/list-bypass-recipient", { name: "bypassOrganizationContactId" })]);
  myForm.addDividerField({ dividerIsHidden: true });
  return myForm;
};

const AddLoanOfficerSalesManagerForm = () => {
  const myForm = addLoanOfficerSalesManagerFormFields(
    new BCFormController(
      {},
      {
        submitSuffix: "/salesteam/loan-officer-sales-manager",
        dataFormatterFunc: (data) => ({ ...data, enableNotificationBypass: false }),
      }
    )
  );

  return <LmsFormGenerator myForm={myForm} actions={["save-close", "close"]} />;
};

const EditLoanOfficerSalesManagerForm = ({ id }) => {
  const [{ data: loanData, isLoading, error }] = useFetchData(`/salesteam/loan-officers/${id}`, {skipCache:true} );
  const myForm = editLoanOfficerSalesManagerFormFields(new BCFormController(loanData, { submitSuffix: "/salesteam/loan-officer-sales-manager", blankWidth: 4 }));
  const formActions = ["save-close", "close"];
  return <LmsFormGenerator myForm={myForm} isLoading={isLoading} error={error} actions={formActions}/>;
};

const LmsSalesTeamLoanOfficerSalesManager = ({ params = {}, history }) => {
  const { isMainPage, isAdd, isEdit, isActionAllowed, id } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (<>
    {isMainPage && <MainTable/>}
    {isAdd && <AddLoanOfficerSalesManagerForm />}
    {isEdit && <EditLoanOfficerSalesManagerForm id={id}/>}
  </>);
};

export default LmsSalesTeamLoanOfficerSalesManager;